var LocalStorageDetailViewTypeServiceImp_1;
import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { API_VIEW_TYPE_TRANSLATE_MAP } from '@/domains/user/constants';
import { PATENT_VIEW_TYPES } from '@/domains/detail/space/constants';
import _ from 'lodash';
export const DetailViewTypeService = Symbol('DetailViewTypeService');
let LocalStorageDetailViewTypeServiceImp = class LocalStorageDetailViewTypeServiceImp {
    static { LocalStorageDetailViewTypeServiceImp_1 = this; }
    static { this.WORKSPACE_DETAIL_VIEW_NAME = 'WORKSPACE_DETAIL_VIEW_NAME'; }
    getDetailViewType() {
        const value = localStorage.getItem(LocalStorageDetailViewTypeServiceImp_1.WORKSPACE_DETAIL_VIEW_NAME);
        return this._transformViewType(value);
    }
    setDetailViewType(type) {
        localStorage.setItem(LocalStorageDetailViewTypeServiceImp_1.WORKSPACE_DETAIL_VIEW_NAME, _.toString(type));
    }
    /**
     * 兼容历史数据，将用户历史数据转为ViewType的数据类型
     */
    _transformViewType(value) {
        if (_.includes(PATENT_VIEW_TYPES, value)) {
            return value;
        }
        if (API_VIEW_TYPE_TRANSLATE_MAP[value]) {
            API_VIEW_TYPE_TRANSLATE_MAP[value];
        }
    }
};
LocalStorageDetailViewTypeServiceImp = LocalStorageDetailViewTypeServiceImp_1 = __decorate([
    injectable()
], LocalStorageDetailViewTypeServiceImp);
export { LocalStorageDetailViewTypeServiceImp };
